import React from "react";
import { Box, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";

const PuzzleStateFilter = ({ value, onChange }) => {
    const states = [
        { value: "", label: "All States" },
        { value: "DRAFT", label: "Draft" },
        { value: "READY_TO_REVIEW", label: "Ready for Review" },
        { value: "REVIEWED", label: "Reviewed" },
        { value: "PUBLISHED", label: "Published" },
        { value: "DISCARDED", label: "Discarded" },
        { value: "DISABLED", label: "Disabled" }
    ];

    const handleChange = (_event, newValue) => {
        if (newValue !== null) {
            onChange({ target: { value: newValue } });
        }
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                Filter by State
            </Typography>
            <ToggleButtonGroup
                value={value || ""}
                exclusive
                onChange={handleChange}
                size="small"
                sx={{ flexWrap: 'wrap', '& .MuiToggleButton-root': { py: 0.25, px: 1, minHeight: 28, fontSize: '0.8125rem' } }}
            >
                {states.map((state) => (
                    <ToggleButton
                        key={state.value}
                        value={state.value}
                        sx={{
                            px: 1,
                            py: 0.25,
                            minHeight: 28,
                            fontSize: '0.8125rem',
                            '&.Mui-selected': {
                                backgroundColor: 'primary.main',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: 'primary.dark',
                                },
                            },
                        }}
                    >
                        {state.label}
                    </ToggleButton>
                ))}
            </ToggleButtonGroup>
        </Box>
    );
};

export default PuzzleStateFilter;

